import { useCallback, useEffect } from "react";
import { App } from "antd";
import { UserData } from "./ChangeUserRoleModal";
import { useUserModalActions } from "./useUserModals";

interface DeleteUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: UserData | null;
  onRefresh?: () => void;
}

const UserDeleteModal = ({
  isOpen,
  onClose,
  user,
  onRefresh,
}: DeleteUserModalProps) => {
  const { modal } = App.useApp();
  const { deleteUser, loading } = useUserModalActions({
    onRefresh,
  });

  const handleDelete = useCallback(
    async (userId: string) => {
      if (!userId) return;
      try {
        await deleteUser({ userId });
        onClose();
      } catch (err) {
        console.error("Error deleting user:", err);
      }
    },
    [deleteUser, onClose],
  );

  useEffect(() => {
    if (!isOpen || !user) return;

    const instance = modal.confirm({
      title: "Delete User",
      content: (
        <>
          <p>Are you sure you want to delete this user?</p>
          <span>
            This will permanently delete the user account and cannot be undone.
            <br />
            <br />
            Note: All data associated with this user will be automatically
            transferred to you (Admin).
          </span>
        </>
      ),
      okText: "Delete",
      closable: true,
      width: 520,
      okButtonProps: { loading },
      onOk: () => handleDelete(user.id),
      onCancel: onClose,
      destroyOnHidden: true,
    });

    return () => {
      instance.destroy();
    };
  }, [isOpen, user, modal, handleDelete, onClose, loading]);

  return null;
};

export default UserDeleteModal;
